<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <br><br>

    <v-layout row wrap>
      <v-flex xs12 md6>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Fornecedores Cadastrados no SIMPAS</strong>
          </p>
        </div>
        <br/>
        <canvas id="languagePie"></canvas>
        <br/>
      </v-flex>

      <v-flex xs12 md6>
        <div class="tituloBox p-b-10 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Cadastros por Tipo no ComprasNet</strong>
          </p>
        </div>
        <div style="height: 50px;">
          <v-select
            style="height: 20%; width:20%; float: right; position: relative;"
            item-end
            v-model="selectAnoPesquisa"
            :items="anosPesquisa"
            dense
          ></v-select>
        </div>
        <canvas id="tipoSolicitacaoStackedBar"></canvas>
        <br/>
      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilSomenteHabilitador()">
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Quantitativo de Solicitações Analisadas</strong>
          </p>
        </div>
        <div class="legenda-dashboard">
          <div
            v-for="item in legendaSolicitacoesAnalisadas"
            :key="item.label"
            class="legenda-item"
          >
            <span class="legenda-cor" :style="{ backgroundColor: item.color }"></span>
            <span>{{ item.label }}</span>
          </div>
        </div>
        <canvas id="validadorSolicitacoesBar"></canvas>
      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilSomenteHabilitador()">
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Quantitativo de Solicitações por Tipo</strong>
          </p>
        </div>
        <div class="legenda-dashboard">
          <div
            v-for="item in legendaTipoCadastro"
            :key="item.label"
            class="legenda-item"
          >
            <span class="legenda-cor" :style="{ backgroundColor: item.color }"></span>
            <span>{{ item.label }}</span>
          </div>
        </div>
        <canvas id="validadorTipoCadastroBar"></canvas>
      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilHabilitadorMaster()">
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Fornecedores Cadastrados por Categoria</strong>
          </p>
        </div>
        <canvas id="categoriaCadastroPie"></canvas>
      </v-flex>

      <v-flex xs12 md6>
        <div class="tituloBox p-b-10 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Top 10 Fornecedores Com Mais Participações Em PCEs</strong>
          </p>
        </div>
        <br/>
        <canvas id="topTenBar"></canvas>
      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilHabilitadorMaster()">
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Quantitativo de solicitações analisadas pelos analistas</strong>
          </p>
        </div>

        <v-layout row class="dashboard-periodo">
          <b>período:</b>

          <v-flex xs12 md4 p0>
            <datePicker
              v-model="dataIni"
              :dataDefault="dataIni"
              v-mask="maskData"
              :limitarData="true"
              :label="'Data Inicial'"
              validate-on-blur
              persistent-hint
            />
          </v-flex>

          <b>a</b>

          <v-flex xs12 md4>
            <datePicker
              v-model="dataFim"
              :dataDefault="dataFim"
              v-mask="maskData"
              :limitarData="true"
              :label="'Data Final'"
              validate-on-blur
              persistent-hint
            />
          </v-flex>

          <v-btn
            style="width: 20%; align-self:center;"
            text
            color="primary"
            @click="montarDashboardQuantitativoSolicitacoes(dataIni, dataFim)"
          >
            Pesquisar
          </v-btn>
        </v-layout>

        <div class="legenda-dashboard">
          <div
            v-for="item in legendaSolicitacoesAnalisadas"
            :key="`analista-${item.label}`"
            class="legenda-item"
          >
            <span class="legenda-cor" :style="{ backgroundColor: item.color }"></span>
            <span>{{ item.label }}</span>
          </div>
        </div>

        <canvas id="topAnalistaBar"></canvas>

      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilHabilitadorMaster()">
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Quantitativo de Solicitações por Tipo</strong>
          </p>
        </div>
        <div class="legenda-dashboard">
          <div
            v-for="item in legendaTipoCadastro"
            :key="`master-${item.label}`"
            class="legenda-item"
          >
            <span class="legenda-cor" :style="{ backgroundColor: item.color }"></span>
            <span>{{ item.label }}</span>
          </div>
        </div>
        <canvas id="masterTipoCadastroBar"></canvas>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import util from "../../../plugins/util";
import Chart from 'chart.js'
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */

const dashboardBarLabelPlugin = {
  afterDatasetsDraw(chart) {
    const allowedCharts = [
      'topAnalistaBar',
      'validadorSolicitacoesBar',
      'validadorTipoCadastroBar',
      'masterTipoCadastroBar',
    ];

    if (!allowedCharts.includes(chart.canvas.id)) {
      return;
    }

    const ctx = chart.ctx;

    const drawBadge = (text, x, y) => {
      const paddingX = 6;
      const paddingY = 3;
      const textWidth = ctx.measureText(text).width;
      const boxWidth = textWidth + paddingX * 2;
      const boxHeight = 18;
      const boxX = x;
      const boxY = y - boxHeight / 2;

      ctx.fillStyle = 'rgba(0, 0, 0, 0.72)';
      ctx.fillRect(boxX, boxY, boxWidth, boxHeight);
      ctx.fillStyle = '#fff';
      ctx.fillText(text, boxX + paddingX, y);
    };

    ctx.save();
    ctx.font = 'bold 12px sans-serif';
    ctx.textBaseline = 'middle';

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      if (!meta || meta.hidden) {
        return;
      }

      meta.data.forEach((element, index) => {
        const value = Number((dataset.data && dataset.data[index]) || 0);

        if (!element || Number.isNaN(value) || value <= 0) {
          return;
        }

        const model = element._model || element._view;
        const barWidth = Math.abs(model.x - model.base);
        const label = String(value);

        if (barWidth > ctx.measureText(label).width + 18) {
          ctx.textAlign = 'left';
          drawBadge(label, Math.min(model.x - barWidth + 4, model.x - ctx.measureText(label).width - 14), model.y);
        } else {
          ctx.textAlign = 'left';
          drawBadge(label, model.x + 8, model.y);
        }
      });
    });

    ctx.restore();
  }
};

if (!Chart.__dashboardBarLabelPluginRegistered) {
  Chart.plugins.register(dashboardBarLabelPlugin);
  Chart.__dashboardBarLabelPluginRegistered = true;
}

export default {
  name: "dashboard",
  components: { /*Componentes utilizados*/
    Migalha,
    Topo
  },
  data() {//Declaracao de variaveis
    return {
      dashTipoCadastroSimpas: [],
      anosPesquisa: [],
      selectAnoPesquisa: null,
      dashCategoriaCadastroSimpas: [],
      dataIni: null,
      dataFim: null,
      legendaSolicitacoesAnalisadas: [
        { label: 'Solicitação de Alteração', color: '#4876FF' },
        { label: 'Inscrição', color: '#CD3333' },
      ],
      legendaTipoCadastro: [
        { label: 'Candidato', color: '#CD3333' },
        { label: 'CRS', color: 'green' },
        { label: 'CRC', color: '#4876FF' },
      ],
      charts: {
        tipoCadastroSimpas: null,
        tipoSolicitacao: null,
        categoriaCadastro: null,
        topTen: null,
        analistas: null,
        validadorSolicitacoes: null,
        validadorTipoCadastro: null,
        masterTipoCadastro: null,
      },
    };
  },
  mixins: [util],
  watch: {
    'selectAnoPesquisa': function(){
      this.montarDashboardTipoSolicitacao();
    },
  },
  created() /*Metodo de start do componente*/{
    this.montarDashboardTipoCadastroSimpas();
    this.gerarAnos();
    this.montarDashboardCategoria();
    this.$store.commit("setAba", {
      abaAtiva: "tab-dados"
    });
  },
  mounted() {
    this.montarDashboardTipoSolicitacao();
    this.montarDashboardTopTen();
    this.montarDashboardQuantitativoSolicitacoes("", "");
    this.carregarDashboardsPorPerfil();
  },
  beforeDestroy() {
    Object.keys(this.charts).forEach((chartKey) => {
      this.destroyChart(chartKey);
    });
  },

  methods: {//Declaracao de todos os metodos
    gerarAnos(){
      var d = new Date();
      var anoCorrente = d.getFullYear();
      this.selectAnoPesquisa = anoCorrente;
      for(var ano=2019; ano<=anoCorrente ; ano++){
        this.anosPesquisa.push(ano);
      }
    },

    carregarDashboardsPorPerfil() {
      if (this.$verificaPerfilSomenteHabilitador()) {
        this.montarDashboardSolicitacoesAnalisadasValidador();
        this.montarDashboardSolicitacoesPorTipoValidador();
      }

      if (this.$verificaPerfilHabilitadorMaster()) {
        this.montarDashboardSolicitacoesPorTipoCadastroMaster();
      }
    },

    destroyChart(chartKey) {
      if (this.charts[chartKey] && typeof this.charts[chartKey].destroy === 'function') {
        this.charts[chartKey].destroy();
      }

      this.charts[chartKey] = null;
    },

    renderChart(chartKey, canvasId, config) {
      const canvas = document.getElementById(canvasId);

      if (!canvas) {
        this.$removePreload();
        return;
      }

      this.destroyChart(chartKey);

      this.$nextTick(() => {
        this.charts[chartKey] = new Chart(canvas, config);
        this.$removePreload();
      });
    },

    obterSerie(dados, caminhos) {
      const listaCaminhos = Array.isArray(caminhos) ? caminhos : [caminhos];

      for (let indice = 0; indice < listaCaminhos.length; indice += 1) {
        const caminho = listaCaminhos[indice];
        const valor = caminho.split('.').reduce((acumulado, chave) => {
          if (acumulado && Object.prototype.hasOwnProperty.call(acumulado, chave)) {
            return acumulado[chave];
          }

          return undefined;
        }, dados);

        if (Array.isArray(valor)) {
          return valor.map((item) => Number(item || 0));
        }
      }

      return [];
    },

    /* método que gera gráfico de tipos de fornecedores cadastrados no SIMPAS
      (CRC, CRS, CREDENCIAMENTO) */
    montarDashboardTipoCadastroSimpas(){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService.carregarDashboard(1).then(response => { /*resposta do servico*/
        this.dashTipoCadastroSimpas = response.data;

        const labels = [
          this.dashTipoCadastroSimpas.legendas.crc,
          this.dashTipoCadastroSimpas.legendas.crs,
          this.dashTipoCadastroSimpas.legendas.credenciamento,
        ];

        const dados = [
          this.dashTipoCadastroSimpas.percentuais.crc,
          this.dashTipoCadastroSimpas.percentuais.crs,
          this.dashTipoCadastroSimpas.percentuais.credenciamento,
        ];

        this.renderChart('tipoCadastroSimpas', 'languagePie', {
          type: 'pie',
          data: {
            labels,
            datasets: [{
              data: dados,
              backgroundColor: ['#CD3333', 'green', '#4876FF'],
              hoverBackgroundColor: ['#CD3333', 'green', '#4876FF']
            }]
          },
          options: {
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index];
                }
              },
              enabled: true,
            },
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'right',
              display: true,
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    /* Método que gera gráfico de tipos de solicitação
      (Novo, Alteração) */
    montarDashboardTipoSolicitacao(){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService.consultarTipoSolicitacaoDashboard(this.selectAnoPesquisa).then(response => { /*resposta do servico*/
        const tipoNovo = this.obterSerie(response.data, ['quantidade.novo', 'novo']);
        const tipoAlteracao = this.obterSerie(response.data, ['quantidade.alteracao', 'alteracao']);
        const labelMeses = response.data.legendas;

        this.renderChart('tipoSolicitacao', 'tipoSolicitacaoStackedBar', {
          type: 'bar',
          data: {
            labels: labelMeses,
            datasets: [
              {
                label: 'Novo',
                data: tipoNovo,
                backgroundColor: '#CD3333',
              },
              {
                label: 'Alteração',
                data: tipoAlteracao,
                backgroundColor: '#4876FF',
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{ stacked: true }],
              yAxes: [{ stacked: true }]
            },
            responsive: true,
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    montarDashboardSolicitacoesAnalisadasValidador() {
      this.$mostrarPreload();
      fornecedorService.consultarQuantitativoSolicitacoesValidadorDashboard().then(response => {
        const labels = response.data.legendas || [];
        const tipoAlteracao = this.obterSerie(response.data, ['quantidadeAlteracao', 'quantidade.alteracao', 'alteracao']);
        const tipoInscricao = this.obterSerie(response.data, ['quantidadeInscricao', 'quantidade.inscricao', 'inscricao']);

        this.renderChart('validadorSolicitacoes', 'validadorSolicitacoesBar', {
          type: 'horizontalBar',
          data: {
            labels,
            datasets: [
              {
                label: 'Solicitação de Alteração',
                backgroundColor: '#4876FF',
                data: tipoAlteracao,
              },
              {
                label: 'Inscrição',
                backgroundColor: '#CD3333',
                data: tipoInscricao,
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{ stacked: true }],
              yAxes: [{ stacked: true }]
            },
            tooltips: {
              enabled: true,
              mode: 'label',
              callbacks: {
                title: function(tooltipItems, data) {
                  var idx = tooltipItems[0].index;
                  return data.labels[idx];
                },
                label: function(tooltipItems) {
                  return tooltipItems.xLabel;
                }
              }
            },
            legend: {
              display: false,
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    montarDashboardSolicitacoesPorTipoValidador() {
      this.$mostrarPreload();
      fornecedorService.consultarQuantitativoSolicitacoesPorTipoDashboard().then(response => {
        const labels = response.data.legendas || [];
        const candidato = this.obterSerie(response.data, ['quantidadeCandidato', 'quantidade.candidato', 'candidato']);
        const crs = this.obterSerie(response.data, ['quantidadeCrs', 'quantidade.crs', 'crs']);
        const crc = this.obterSerie(response.data, ['quantidadeCrc', 'quantidade.crc', 'crc']);

        this.renderChart('validadorTipoCadastro', 'validadorTipoCadastroBar', {
          type: 'horizontalBar',
          data: {
            labels,
            datasets: [
              {
                label: 'Candidato',
                backgroundColor: '#CD3333',
                data: candidato,
              },
              {
                label: 'CRS',
                backgroundColor: 'green',
                data: crs,
              },
              {
                label: 'CRC',
                backgroundColor: '#4876FF',
                data: crc,
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{ stacked: true }],
              yAxes: [{ stacked: true }]
            },
            tooltips: {
              enabled: true,
              mode: 'label',
              callbacks: {
                title: function(tooltipItems, data) {
                  var idx = tooltipItems[0].index;
                  return data.labels[idx];
                },
                label: function(tooltipItems) {
                  return tooltipItems.xLabel;
                }
              }
            },
            legend: {
              display: false,
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    montarDashboardSolicitacoesPorTipoCadastroMaster() {
      this.$mostrarPreload();
      fornecedorService.consultarQuantitativoSolicitacoesPorTipoCadastroMasterDashboard(this.dataIni, this.dataFim).then(response => {
        const labels = response.data.legendas || [];
        const candidato = this.obterSerie(response.data, ['quantidadeCandidato', 'quantidade.candidato', 'candidato']);
        const crs = this.obterSerie(response.data, ['quantidadeCrs', 'quantidade.crs', 'crs']);
        const crc = this.obterSerie(response.data, ['quantidadeCrc', 'quantidade.crc', 'crc']);

        this.renderChart('masterTipoCadastro', 'masterTipoCadastroBar', {
          type: 'horizontalBar',
          data: {
            labels,
            datasets: [
              {
                label: 'Candidato',
                backgroundColor: '#CD3333',
                data: candidato,
              },
              {
                label: 'CRS',
                backgroundColor: 'green',
                data: crs,
              },
              {
                label: 'CRC',
                backgroundColor: '#4876FF',
                data: crc,
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{ stacked: true }],
              yAxes: [{ stacked: true }]
            },
            tooltips: {
              enabled: true,
              mode: 'label',
              callbacks: {
                title: function(tooltipItems, data) {
                  var idx = tooltipItems[0].index;
                  return data.labels[idx];
                },
                label: function(tooltipItems) {
                  return tooltipItems.xLabel;
                }
              }
            },
            legend: {
              display: false,
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    montarDashboardQuantitativoSolicitacoes(dataIni,dataFim){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService.consultarQuantitativoSolicitacoesDashboard(dataIni,dataFim).then(response => { /*resposta do servico*/
        this.dashCategoriaCadastroSimpas = response.data

        const tipoInscricao = this.obterSerie(response.data, ['quantidadeInscricao', 'quantidade.inscricao', 'inscricao']);
        const tipoAlteracao = this.obterSerie(response.data, ['quantidadeAlteracao', 'quantidade.alteracao', 'alteracao']);

        this.renderChart('analistas', 'topAnalistaBar', {
          type: 'horizontalBar',
          data: {
            labels: response.data.legendas,
            datasets: [
              {
                label: 'Quantitativo de Solicitações Analisadas no Dia (Solicitação de Alteração) ',
                backgroundColor: '#4876FF',
                data: tipoAlteracao
              },
              {
                label: 'Quantitativo de Solicitações Analisadas no Dia (Inscrição)',
                backgroundColor: '#CD3333',
                data: tipoInscricao
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{ stacked: true }],
              yAxes: [{ stacked: true }]
            },
            tooltips: {
              enabled: true,
              mode: 'label',
              callbacks: {
                title: function(tooltipItems, data) {
                  var idx = tooltipItems[0].index;
                  return data.labels[idx];
                },
                label: function(tooltipItems) {
                  return tooltipItems.xLabel;
                }
              }
            },
            legend: {
              display: false,
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    /* Método que gera gráfico de fornecedores cadastrados por categoria
      (NO, MEI, ME, EPP, ES, ES, AF) */
    montarDashboardCategoria(){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService.carregarDashboard(3).then(response => { /*resposta do servico*/
        this.dashCategoriaCadastroSimpas = response.data

        const labels = [
          this.dashCategoriaCadastroSimpas.legendas.no,
          this.dashCategoriaCadastroSimpas.legendas.mei,
          this.dashCategoriaCadastroSimpas.legendas.me,
          this.dashCategoriaCadastroSimpas.legendas.epp,
          this.dashCategoriaCadastroSimpas.legendas.es,
          this.dashCategoriaCadastroSimpas.legendas.ec,
          this.dashCategoriaCadastroSimpas.legendas.af,
        ];

        const dados = [
          this.dashCategoriaCadastroSimpas.percentuais.no,
          this.dashCategoriaCadastroSimpas.percentuais.mei,
          this.dashCategoriaCadastroSimpas.percentuais.me,
          this.dashCategoriaCadastroSimpas.percentuais.epp,
          this.dashCategoriaCadastroSimpas.percentuais.es,
          this.dashCategoriaCadastroSimpas.percentuais.ec,
          this.dashCategoriaCadastroSimpas.percentuais.af,
        ];

        this.renderChart('categoriaCadastro', 'categoriaCadastroPie', {
          type: 'pie',
          data: {
            labels,
            datasets: [{
              data: dados,
              backgroundColor: ['#CD3333', 'silver', '#4876FF', 'green', 'orange', 'purple', 'pink'],
              hoverBackgroundColor: ['#CD3333', 'silver', '#4876FF', 'green', 'orange', 'purple', 'pink']
            }]
          },
          options: {
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index];
                }
              },
              enabled: true,
            },
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'right',
              display: true,
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    },

    /* Método que gera gráfico de fornecedorescom mais
    participações em PCEs - Top 10 */
    montarDashboardTopTen(){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService.carregarDashboard(4).then(response => { /*resposta do servico*/
        this.dashCategoriaCadastroSimpas = response.data

        this.renderChart('topTen', 'topTenBar', {
          type: 'horizontalBar',
          data: {
            labels: response.data.legendas,
            datasets: [{
              label: 'Participações em PCEs',
              backgroundColor: '#3366ff',
              data: response.data.quantidade
            }]
          },
          options: {
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }],
              yAxes: [{
                ticks: {
                  callback: function(value) {
                    if (value.length > 20) {
                      return value.substr(0, 20) + '...'; //truncate
                    } else {
                      return value
                    }
                  },
                }
              }]
            },
            tooltips: {
              enabled: true,
              mode: 'label',
              callbacks: {
                title: function(tooltipItems, data) {
                  var idx = tooltipItems[0].index;
                  return data.labels[idx];
                },
                label: function(tooltipItems) {
                  return tooltipItems.xLabel;
                }
              }
            },
          }
        });
      }).catch(() => {
        this.$removePreload();
      });
    }
  }
};
</script>
<style scoped>
b{
  align-self:center;
}

.legenda-dashboard {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0 12px;
}

.legenda-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.legenda-cor {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  display: inline-block;
}

.dashboard-periodo {
  align-items: center;
  gap: 8px;
}

</style>
